import {
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_FAILURE,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST,
  CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS,
  CONTRACT_SETUP_ALL_STATE_CLEAR,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

type ErrorState = string | null;

const initialState: ErrorState = null;

export default function reducer(state: ErrorState = initialState, action: ContractSetupAction) {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_REQUEST:
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_SUCCESS:
      return initialState;
    case CONTRACT_SETUP__DOCUMENT_PARTICIPANTS_FETCH_FAILURE:
      return action.payload.message;
    default:
      return state;
  }
}
